import { render, staticRenderFns } from "./CouponIssuanceUsePopup.vue?vue&type=template&id=52b0bba1&scoped=true&"
import script from "./CouponIssuanceUsePopup.vue?vue&type=script&lang=ts&"
export * from "./CouponIssuanceUsePopup.vue?vue&type=script&lang=ts&"
import style0 from "./CouponIssuanceUsePopup.vue?vue&type=style&index=0&id=52b0bba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0bba1",
  null
  
)

export default component.exports